import request from '@/service/request';

export const UpdateQuote = (
  productType: string,
  productKey: string,
  planKey: string,
  quotationId: string,
  data: any,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productKey}/plans/${planKey}/quotation/${quotationId}`,
    {
      method: 'put',
      data,
    },
  );
};

export const CreateShare = (
  productType: string,
  productKey: string,
  planKey: string,
  quotationId: string,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productKey}/plans/${planKey}/quotation/${quotationId}/share`,
    {
      method: 'post',
    },
  );
};

export const GetQuotation = (quotationId: string) => {
  return request(
    `/v1/agency-platform-vn-v2/agency/quotes/${quotationId}?id_type=ext_id`,
  );
};

export const GetProductDetail = (productType: string, productId: any) => {
  return request(
    `/v1/shaft/public/class/ips/vn/${productType}/products/${productId}`,
  );
};

export const GetPlanCmsDetail = (
  productType: string,
  productId: any,
  planId: string,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productId}/plans/cms/${planId}`,
  );
};

export const GetPlanDetail = (
  productType: string,
  productId: any,
  planId: string,
) => {
  return request(
    `/v1/shaft/public/class/ips/vn/${productType}/products/${productId}/plans/${planId}`,
  );
};

export const QuotationConfirm = (
  productType: string,
  productKey: string,
  planKey: string,
  quotationId: string,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productKey}/plans/${planKey}/quotation/${quotationId}/state`,
    {
      method: 'put',
    },
  );
};
